import { useFormikContext } from "formik";
import { getInitialLocation } from "../utils";
import useQueryParams from "src/hooks/useQueryParams";

export default function useAddNewLocations() {
  const { values, setFieldValue } = useFormikContext();
  const params = useQueryParams();
  const shipmentId = params.get("shipmentId");

  const addNewLocations = (palletCount, quantity) => {
    const newLocations = Array.from({ length: palletCount }, () =>
      getInitialLocation(quantity, shipmentId)
    );

    if (
      values.locations.length === 1 &&
      values.locations[0].new === true &&
      values.locations[0].sub_qty === 0
    ) {
      setFieldValue("locations", newLocations);
    } else {
      setFieldValue("locations", [...values.locations, ...newLocations]);
    }
  };

  return { addNewLocations };
}
